export const NETWORK_ERROR = "We're sorry, but the server appears to be experiencing issues. Please try refreshing. If you still see this error after refreshing, please notify your event host or contact robert@hellomatch.us for help.";
